import request from '@/config/axios'

export interface LiveRankVO {
  id?: number
  roomId?: number
  memberId?: number
  expValue?: number
}

export const pageRank = (params: any) => request.get({ url: '/live/rank/page', params })
export const getRank = (id: number) =>
  request.get({ url: '/live/rank/get', params: { id } })
